export default {
    BASE_URL: '/crm',
    api: [
        {
            name: 'list',
            desc: '获取企业员工列表',
            method: 'GET',
            path: '/employees'
        },
        {
            name: 'detail',
            desc: '获取员工信息',
            method: 'GET',
            path: '/employees/info'
        },
        {
            name: 'insert',
            desc: '添加员工',
            method: 'POST',
            path: '/employees/insert'
        },
        {
            name: 'updatePost',
            desc: '变更职位',
            method: 'PUT',
            path: '/employees/updatePost'
        },
        {
            name: 'leave',
            desc: '员工离职',
            method: 'DELETE',
            path: '/employees/leave/{id}'
        },
        {
            name: 'roleList',
            desc: '获取角色列表',
            method: 'GET',
            path: '/employees/role/list'
        },
        {
            name: 'projList',
            desc: '获取项目列表',
            method: 'GET',
            path: '/member/project/list'
        },
        {
            name: 'authProject',
            desc: '授权项目',
            method: 'POST',
            path: '/member/project/authorize'
        },
        {
            name: 'manager',
            desc: '管理人员列表',
            method: 'GET',
            path: '/member/select/list'
        },
        {
            name: 'historyList',
            desc: '在建/历史列表',
            method: 'GET',
            path: '/employees/hist/project/list'
        },
        {
            name: 'resetPassword',
            desc: '重置密码',
            method: 'POST',
            path: '/employees/resetPassword'
        },
        {
            name: 'comRolesList',
            desc: '编辑员工时，获取公司角色列表',
            method: 'GET',
            path: '/employees/role/name'
        },
        {
            name: 'editEmpSave',
            desc: '编辑员工保存',
            method: 'POST',
            path: '/employees/edit'
        }
    ]
}



// WEBPACK FOOTER //
// ./src/api/employees/index.js